/**
 * addThreeDots function for add 3 dots string in last
 * that overflow from a form.
 */
export function addThreeDots(value) {
  const threeDots = value?.length >= 30 ? '...' : '';
  return threeDots;
}
